export default {"src":"/_next/static/media/star_blink.6dee804d.svg","height":11,"width":11};